import React from 'react';

const providers = [
  {
    name: 'Belfast Studio Collective',
    category: 'Hair and beauty',
    area: 'Central Belfast',
    note: 'Strong category mix, visible portfolio direction, and booking-readiness.',
  },
  {
    name: 'North Quarter Barber House',
    category: 'Barber and beard',
    area: 'North Belfast',
    note: 'High-trust local barbering profile with repeat-service potential.',
  },
  {
    name: 'Luna Ink and Piercing',
    category: 'Tattoo and piercing',
    area: 'East Belfast',
    note: 'Portfolio-led discovery with strong style-specific browsing potential.',
  },
];

export default function FindProviderPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1120px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#4f46e5',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              fontSize: '0.9rem',
            }}
          >
            Find a service provider
          </p>
          <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '12ch' }}>
            Search and compare local providers more clearly
          </h1>
          <p
            style={{
              margin: 0,
              color: '#475569',
              lineHeight: 1.8,
              fontSize: '1.05rem',
              maxWidth: '72ch',
            }}
          >
            Your HnB documents call for a public provider search experience with
            category filters, postcode or location search, ratings, pricing context,
            and a path into deeper comparison.
          </p>
        </div>
      </section>

      <section style={{ padding: '40px 24px' }}>
        <div
          style={{
            maxWidth: '1120px',
            margin: '0 auto',
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '20px',
            padding: '20px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px',
          }}
        >
          <input
            type="text"
            placeholder="Search by provider, area, or postcode"
            style={{ padding: '12px 14px', borderRadius: '10px', border: '1px solid #d1d5db' }}
          />
          <select
            style={{ padding: '12px 14px', borderRadius: '10px', border: '1px solid #d1d5db', background: '#fff' }}
          >
            <option>All categories</option>
            <option>Hair</option>
            <option>Beard</option>
            <option>Nails</option>
            <option>Tattoo</option>
            <option>Piercing</option>
          </select>
          <select
            style={{ padding: '12px 14px', borderRadius: '10px', border: '1px solid #d1d5db', background: '#fff' }}
          >
            <option>All ratings</option>
            <option>4.5 and above</option>
            <option>4.0 and above</option>
          </select>
          <button
            type="button"
            style={{
              background: '#111827',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              padding: '12px 16px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Search
          </button>
        </div>
      </section>

      <section style={{ padding: '0 24px 72px' }}>
        <div
          style={{
            maxWidth: '1120px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: '1.2fr 0.8fr',
            gap: '18px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {providers.map((provider) => (
              <div
                key={provider.name}
                style={{
                  background: '#ffffff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '18px',
                  padding: '22px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <h2 style={{ margin: 0, fontSize: '1.15rem' }}>{provider.name}</h2>
                <p style={{ margin: 0, color: '#4338ca', fontWeight: 600 }}>
                  {provider.category} · {provider.area}
                </p>
                <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.75 }}>{provider.note}</p>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <button
                    type="button"
                    style={{
                      background: '#111827',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '10px',
                      padding: '11px 14px',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    View profile
                  </button>
                  <button
                    type="button"
                    style={{
                      background: '#ffffff',
                      color: '#111827',
                      border: '1px solid #d1d5db',
                      borderRadius: '10px',
                      padding: '11px 14px',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    Compare services
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div
            style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '18px',
              padding: '22px',
              height: 'fit-content',
            }}
          >
            <h2 style={{ margin: '0 0 10px 0', fontSize: '1.15rem' }}>Map and location view</h2>
            <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.75 }}>
              This placeholder panel can later become the public map-based provider
              search surface, using approximate location and privacy-conscious distance
              display as described in your HnB planning documents.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}